import { setRooftopPosition } from './set-rooftop-position';

const NAV_LIST_SELECTOR = '#main-nav .nav-list__item';

const nodeListToArray = nodeList => Array.prototype.slice.call(nodeList);

export const addNavHandlers = (parsedUrl) => {
    const mainNav = nodeListToArray(document.querySelectorAll(NAV_LIST_SELECTOR));
    const navHeaderLink = nodeListToArray(document.querySelectorAll(`${NAV_LIST_SELECTOR} > a`));
    const menuExpandBtn = nodeListToArray(document.querySelectorAll('.expand-menu.sr-only'));
    const menuLinks = nodeListToArray(document.querySelectorAll('.inner-list__link'));

    mainNav.forEach(el => {
        el.addEventListener('mouseenter', function() {
            const id = this.getAttribute('id').replace('main-nav-', '');
            setRooftopPosition(id, parsedUrl);
        });
        el.addEventListener('mouseleave', function() {
            setRooftopPosition(false, parsedUrl);
        });
    });

    navHeaderLink.forEach(el => {
        el.addEventListener('focus', function() {
            const id = this.parentElement.getAttribute('id').replace('main-nav-', '');
            setRooftopPosition(id, parsedUrl);
        });
    });

    menuExpandBtn.forEach(el => {
        el.addEventListener('click', function() {
            const id = this.parentElement.getAttribute('id');
            document.querySelector(`#${id} .inner-list`).classList.add('menu-open');
            document.querySelector('.expand-menu.sr-only').setAttribute('aria-expanded', true);
        });
    });

    menuLinks.forEach(el => {
        el.addEventListener('blur', function() {
            const menuItems = document.querySelectorAll('.menu-open .inner-list__item .inner-list__link');
            const isLastMenuItem = this === menuItems[menuItems.length - 1];
            const menuOpen = document.querySelector('.menu-open');
            if(isLastMenuItem && menuOpen) {
                menuOpen.classList.remove('menu-open');
            }
        });
    });
};



// WEBPACK FOOTER //
// ./js/nav/nav-handlers.js